import { render, staticRenderFns } from "./BlogDetail.vue?vue&type=template&id=739629b1"
import script from "./BlogDetail.vue?vue&type=script&lang=js"
export * from "./BlogDetail.vue?vue&type=script&lang=js"
import style0 from "./BlogDetail.vue?vue&type=style&index=0&id=739629b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports